<template>
  <div class="news-container">

    <!-- 新闻标题 -->
    <h1 class="news-title">{{ $t('newsinfo.factory.title') }}</h1>

    <!-- 新闻摘要 -->
    <div class="news-summary">
      {{ $t('newsinfo.factory.summary') }}
      <div class="left-border"></div>
    </div>

    <!-- 新闻横幅 -->
    <div class="news-banner">
      <img 
        src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_cb20250316090033101005.jpg" 
        :alt="$t('newsinfo.factory.bannerAlt')"
      >
    </div>

    <!-- 新闻正文 -->
    <div class="news-content">
      <p class="news-corporation"></p>
      
      <!-- 第一段 -->
      <p>{{ $t('newsinfo.factory.paragraph1') }}</p>
      
      <!-- 第二段 -->
      <p>{{ $t('newsinfo.factory.paragraph2') }}</p>
      
      <!-- 第三段 -->
      <p>{{ $t('newsinfo.factory.paragraph3') }}</p>
      
      <!-- 第一张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250228201937713058.png" 
          :alt="$t('newsinfo.factory.image1.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image1.caption') }}
        </div>
      </div>
      
      <!-- 居中标题1 -->
      <p class="center-title"><strong>{{ $t('newsinfo.factory.sectionTitle1') }}</strong></p>
      
      <!-- 第四段 -->
      <p>{{ $t('newsinfo.factory.paragraph4') }}</p>
      
      <!-- 第五段 -->
      <p>{{ $t('newsinfo.factory.paragraph5') }}</p>
      
      <!-- 第二张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250316090221196046.jpg" 
          :alt="$t('newsinfo.factory.image2.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image2.caption') }}
        </div>
      </div>
      
      <!-- 第六段 -->
      <p>{{ $t('newsinfo.factory.paragraph6') }}</p>
      
      <!-- 第七段 -->
      <p>{{ $t('newsinfo.factory.paragraph7') }}</p>
      
      <!-- 第三张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250228202513582043.png" 
          :alt="$t('newsinfo.factory.image3.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image3.caption') }}
        </div>
      </div>
      
      <!-- 居中标题2 -->
      <p class="center-title"><strong>{{ $t('newsinfo.factory.sectionTitle2') }}</strong></p>
      
      <!-- 第八段 -->
      <p>{{ $t('newsinfo.factory.paragraph8') }}</p>
      
      <!-- 第九段 -->
      <p>{{ $t('newsinfo.factory.paragraph9') }}</p>
      
      <!-- 第十段 -->
      <p>{{ $t('newsinfo.factory.paragraph10') }}</p>
      
      <!-- 第四张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250316091045397070.jpg" 
          :alt="$t('newsinfo.factory.image4.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image4.caption') }}
        </div>
      </div>
      
      <!-- 第十一段 -->
      <p>{{ $t('newsinfo.factory.paragraph11') }}</p>
      
      <!-- 第十二段 -->
      <p>{{ $t('newsinfo.factory.paragraph12') }}</p>
      
      <!-- 第十三段 -->
      <p>{{ $t('newsinfo.factory.paragraph13') }}</p>
      
      <!-- 第十四段 -->
      <p>{{ $t('newsinfo.factory.paragraph14') }}</p>
      
      <!-- 第五张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250228203143212004.png" 
          :alt="$t('newsinfo.factory.image5.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image5.caption') }}
        </div>
      </div>
      
      <!-- 第十五段 -->
      <p>{{ $t('newsinfo.factory.paragraph15') }}</p>
      
      <!-- 居中标题3 -->
      <p class="center-title"><strong>{{ $t('newsinfo.factory.sectionTitle3') }}</strong></p>
      
      <!-- 第十六段 -->
      <p>{{ $t('newsinfo.factory.paragraph16') }}</p>
      
      <!-- 第十七段 -->
      <p>{{ $t('newsinfo.factory.paragraph17') }}</p>
      
      <!-- 第十八段 -->
      <p>{{ $t('newsinfo.factory.paragraph18') }}</p>
      
      <!-- 第十九段 -->
      <p>{{ $t('newsinfo.factory.paragraph19') }}</p>
      
      <!-- 第六张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250228201802565097.png" 
          :alt="$t('newsinfo.factory.image6.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image6.caption') }}
        </div>
      </div>
      
      <!-- 第二十段 -->
      <p>{{ $t('newsinfo.factory.paragraph20') }}</p>
      
      <!-- 第二十一段 -->
      <p>{{ $t('newsinfo.factory.paragraph21') }}</p>
      
      <!-- 第七张图片 -->
      <div class="jf-imgborder center">
        <img 
          src="https://www.healthcode.com/media/news/shanghaiviwernews_files/l_CB20250228202057821008.png" 
          :alt="$t('newsinfo.factory.image7.alt')"
        >
        <div class="image-caption">
          {{ $t('newsinfo.factory.image7.caption') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const currentLang = computed(() => locale.value);

const switchLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem('locale', lang);
};

// 监听语言变化并执行相应操作
watch(locale, (newLocale) => {
  console.log(`语言已切换到: ${newLocale}`);
});

// 页面加载后执行的初始化操作
// 可以在这里添加图片懒加载、统计等逻辑
console.log('新闻页面加载完成');
</script>

<style scoped>
.news-container {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #333;
  line-height: 1.6;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
}

/* 语言切换按钮样式 */
.language-switcher {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  gap: 5px;
}

.language-switcher button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.language-switcher button:hover {
  background-color: #e0e0e0;
}

.language-switcher button.active {
  background-color: #2e3b7a;
  color: white;
  border-color: #2e3b7a;
}

.news-title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0 12px;
  color: #232323;
  line-height: 1.4;
  margin-top: 100px;
}

.news-summary {
  position: relative;
  margin: 0 0 20px;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-left: 4px solid #e60012;
  color: #666;
  font-size: 16px;
}

.news-summary .left-border {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #e60012;
}

.news-banner {
  margin: 0 0 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.news-banner img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.news-banner img:hover {
  transform: scale(1.02);
}

.news-content {
  margin-bottom: 40px;
}

.news-content p {
  margin: 0 0 16px;
  font-size: 17px;
  text-align: justify;
  word-break: break-word;
}

.news-content .center-title {
  text-align: center !important;
  margin: 24px 0 !important;
  font-size: 18px !important;
  color: #1a1a1a;
}

.jf-imgborder {
  margin: 24px 0;
  text-align: center;
}

.jf-imgborder.center {
  text-align: center;
}

.jf-imgborder img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
}

.image-caption {
  color: #888;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  margin-top: 8px;
  padding: 0 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-container {
    padding: 0 12px;
  }
  
  .news-title {
    font-size: 22px;
    margin: 16px 0 10px;
  }
  
  .news-content p {
    font-size: 16px;
    margin-bottom: 14px;
  }
  
  .news-summary {
    padding: 10px 14px;
    font-size: 15px;
  }
  
  .language-switcher {
    position: static;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .news-container {
    padding: 0 10px;
  }
  
  .news-title {
    font-size: 20px;
  }
  
  .news-content p {
    font-size: 15px;
    margin-bottom: 12px;
  }
  
  .image-caption {
    font-size: 13px;
  }
  
  .center-title {
    font-size: 16px !important;
  }
}

/* 暗色模式支持 */
@media (prefers-color-scheme: dark) {
  .news-container {
    color: #e0e0e0;
    background-color: #1a1a1a;
  }
  
  .news-title {
    color: #ffffff;
  }
  
  .news-summary {
    background-color: #2a2a2a;
    color: #b0b0b0;
  }
  
  .center-title {
    color: #ffffff;
  }
  
  .image-caption {
    color: #999;
  }
}

/* 打印样式 */
@media print {
  .news-container {
    max-width: 100%;
    padding: 0;
  }
  
  .news-banner {
    box-shadow: none;
  }
  
  .news-banner img {
    max-height: 300px;
    object-fit: contain;
  }
  
  .news-content p {
    font-size: 16px;
    line-height: 1.5;
  }
  
  .language-switcher {
    display: none;
  }
}
</style>